/*
  km-konfigurator-schritte.js · Kirchberger Metall
  Führt den Konfigurator als Schrittfolge: Akkordeon mit Nummer, Zusammenfassung und
  Status, dazu eine klebende Fortschrittsleiste mit Sprung zum nächsten offenen Schritt.

  Bewusst eigenständig gehalten wie km-konfigurator-anfrage.js: Diese Datei liest den
  Zustand aus dem Formular und die Bezeichnungen aus den Regeln. Sie rechnet nichts und
  fasst die Zeichenlogik in km-konfigurator.js nicht an.

  Bedingte Schritte (Farbe steckt im Materialschritt, Handlauf ist ein eigener) richten
  sich danach, ob ihr Feld sichtbar ist. km-konfigurator.js schaltet das über
  data-show-if; hier wird nur gelesen.
*/
(function () {
  function init(root) {
    var sid = root.getAttribute('data-section-id');
    var form = document.getElementById('km-form-' + sid);
    var regelnEl = document.getElementById('km-rules-' + sid);
    if (!form || !regelnEl) return;

    var R = JSON.parse(regelnEl.textContent);
    var schritte = [].slice.call(root.querySelectorAll('.km-step'));
    if (!schritte.length) return;

    var leiste = document.getElementById('km-fortschritt-' + sid);
    var leisteText = leiste && leiste.querySelector('[data-fortschritt-text]');
    var leistePunkte = leiste && leiste.querySelector('[data-fortschritt-punkte]');
    var leisteWeiter = leiste && leiste.querySelector('[data-fortschritt-weiter]');
    var offenHinweis = document.getElementById('km-offen-' + sid);

    // Fertigungsdauer haengt am Material: beschichtete Teile gehen nach dem Verzinken
    // noch durch die Pulverbeschichtung. Zahlen von Martin Kirchberger, 05.09.2026.
    var zeitFeld = root.querySelector('[data-zeit-fertigung]');
    var zeitPunkte = [].slice.call(root.querySelectorAll('.km-zeit__punkt'));
    var zeitHinweis = root.querySelector('[data-zeit-hinweis]');
    var zeitVorsatz = root.querySelector('[data-zeit-vorsatz]');
    var hilfeZusage = root.querySelector('.km-hilfe__zusage');

    // Vorbelegte Werte sind Startwerte, keine Kundenangaben. Ein Haken erscheint erst,
    // wenn der Besucher in diesem Schritt tatsaechlich etwas ausgewaehlt oder eingegeben
    // hat - sonst stehen beim Laden vier von fuenf Schritten auf gruen, obwohl niemand
    // etwas entschieden hat. Ausnahme: Schritte ohne echte Auswahl (z. B. Material auf
    // einer Produktseite mit festem Material und ohne Farbwahl) gelten sofort als
    // erledigt, dort gibt es nichts zu entscheiden.
    var beruehrt = {};
    var FELD_SCHRITT = {
      material: 'material', farbe: 'material', farbe_wunsch: 'material',
      befestigung: 'befestigung', breite: 'masse', hoehe: 'masse',
      handlauf: 'handlauf', set: 'sets'
    };
    function merkeBeruehrung(el) {
      if (!el || !el.name) return;
      var schritt = FELD_SCHRITT[el.name];
      if (schritt) beruehrt[schritt] = true;
    }
    // Gibt es in diesem Schritt ueberhaupt etwas zu waehlen? Radiogruppen mit nur einer
    // Option, versteckte Felder und feste Anzeigen zaehlen nicht.
    function hatAuswahl(schritt) {
      var koerper = schritt.querySelector('.km-step__body');
      if (!koerper) return false;
      var offen = function (el) {
        var n = el;
        while (n && n !== koerper) { if (n.hidden) return false; n = n.parentElement; }
        return true;
      };
      var gruppen = {};
      var radios = koerper.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (!offen(radios[i])) continue;
        gruppen[radios[i].name] = (gruppen[radios[i].name] || 0) + 1;
      }
      for (var g in gruppen) if (gruppen[g] > 1) return true;
      var selects = koerper.querySelectorAll('select');
      for (var j = 0; j < selects.length; j++) if (offen(selects[j]) && selects[j].options.length > 1) return true;
      var felder = koerper.querySelectorAll('input[type="number"], input[type="text"]');
      for (var k = 0; k < felder.length; k++) if (offen(felder[k])) return true;
      return false;
    }

    function wert(name) {
      var el = form.elements[name];
      if (!el) return '';
      if (el.length && el[0] && el[0].type === 'radio') {
        for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value;
        return '';
      }
      return el.value;
    }

    function labelFuer(liste, id) {
      for (var i = 0; i < liste.length; i++) if (liste[i].id === id) return liste[i].label;
      return '';
    }

    // Gleicher Haken wie in der USP-Leiste: Stroke-SVG statt Glyph. Das Zeichen U+2713
    // wird je nach Schriftschnitt unterschiedlich dick gerendert - im gruenen Kreis fiel
    // das direkt neben der Leiste auf.
    function haken(px) {
      return '<svg viewBox="0 0 24 24" width="' + px + '" height="' + px + '" fill="none" '
        + 'stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" '
        + 'aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
    }

    function sichtbar(schritt) {
      var bedingt = schritt.getAttribute('data-step-if');
      if (!bedingt) return true;
      var feld = schritt.querySelector('[data-show-if="' + bedingt + '"]');
      return !!feld && !feld.hidden;
    }

    // Solange ein Schritt nur seine Vorbelegung traegt, steht in der Kopfzeile eine
    // Aufforderung statt des Werts. Sonst liest sich "Ohne" oder "Vorgesetzt mit
    // Edelstahl Abstandshalter" wie eine bereits getroffene Entscheidung.
    var HINWEIS = {
      befestigung: 'Befestigung vorgesetzt oder in der Laibung?',
      masse: 'Bitte Maße eintragen!',
      handlauf: 'Bitte Handlauf wählen',
      sets: 'Bitte Befestigungsmaterial wählen'
    };

    function hinweisNoetig(schritt, name) {
      if (!HINWEIS[name] || beruehrt[name]) return false;
      // Wo es nichts zu waehlen gibt, ist der vorbelegte Wert die Antwort.
      return name === 'masse' ? true : hatAuswahl(schritt);
    }

    // Was in der Kopfzeile steht, sobald der Schritt zugeklappt ist.
    function zusammenfassung(name, schritt) {
      if (schritt && hinweisNoetig(schritt, name)) return HINWEIS[name];
      return wertText(name);
    }

    function wertText(name) {
      if (name === 'material') {
        var mat = labelFuer(R.material.optionen, wert('material'));
        var farbFeld = root.querySelector('[data-show-if="farbe"]');
        if (farbFeld && !farbFeld.hidden && wert('farbe')) {
          // Bei "Farbe nach Wahl" steht der eingegebene Farbton in der Kopfzeile,
          // nicht das generische Auswahl-Label.
          var wunschBox = root.querySelector('[data-farbe-wunsch]');
          var wunsch = wunschBox && !wunschBox.hidden ? wert('farbe_wunsch') : '';
          return mat + ' · ' + (wunsch ? wunsch : wert('farbe'));
        }
        return mat;
      }
      if (name === 'befestigung') return labelFuer(R.befestigung.optionen, wert('befestigung'));
      if (name === 'masse') {
        var b = wert('breite'), h = wert('hoehe');
        if (!b) return '';
        // Ein Mass genuegt, wo die Hoehe fest ist - "250 × 1000 mm" waere bei einer Stange irrefuehrend.
        if (R.hoehe && R.hoehe.fest) return b + ' mm';
        if (!h) return '';
        return b + ' × ' + h + ' mm';
      }
      if (name === 'handlauf') return wert('handlauf');
      // Zusatzoption mit Aufpreis - bei den Fenstergittern die Funktion zum Oeffnen.
      // Ohne diesen Zweig liefert wertText '' und der Schritt blieb dauerhaft grau,
      // weil erledigt() einen leeren Wert als "noch nichts gewaehlt" liest.
      if (name === 'oeffnung') {
        if (!R.oeffnung) return '';
        var oeText = labelFuer(R.oeffnung.optionen, wert('oeffnung'));
        // Schlosszahl zur Hoehe in die Kopfzeile (rules.oeffnung.schloesser, 09.10.2026)
        var sl = R.oeffnung.schloesser;
        if (sl && oeText && wert('oeffnung') !== 'ohne') {
          var n = Number(wert('hoehe')) >= Number(sl.ab_hoehe) ? Number(sl.anzahl_ab) : Number(sl.anzahl_unter);
          oeText += ' · ' + (n === 1 ? '1 Schloss' : n + ' Schlösser');
        }
        return oeText;
      }
      if (name === 'sets') return labelFuer(R.sets.optionen, wert('set'));
      return '';
    }

    function erledigt(schritt, name) {
      if (name === 'masse') return !!beruehrt.masse && !!wert('breite') && !!wert('hoehe');
      if (!wertText(name)) return false;
      return !!beruehrt[name] || !hatAuswahl(schritt);
    }

    // Wer einen Schritt aufmacht, hat die Vorauswahl gesehen. Laesst er sie stehen, ist das
    // eine Entscheidung - der Schritt gilt dann als erledigt. Ohne diese Regel bliebe der
    // Haken bei Befestigung, Handlauf und Befestigungsmaterial grau, obwohl der Kunde
    // bewusst nichts geaendert hat. Ausnahme: die Masse, dort zaehlt nur eine echte Eingabe.
    function aufklappen(schritt, auf, merken) {
      var knopf = schritt.querySelector('.km-step__toggle');
      var koerper = schritt.querySelector('.km-step__body');
      knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
      koerper.hidden = !auf;
      schritt.classList.toggle('is-offen', auf);
      if (auf && merken !== false) {
        var name = schritt.getAttribute('data-step');
        if (name && name !== 'masse') beruehrt[name] = true;
      }
    }

    function aktive() {
      for (var i = 0; i < schritte.length; i++) {
        if (schritte[i].classList.contains('is-offen')) return schritte[i];
      }
      return null;
    }

    function naechsterOffener(ab) {
      var start = ab ? schritte.indexOf(ab) + 1 : 0;
      for (var i = start; i < schritte.length; i++) {
        if (sichtbar(schritte[i]) && !erledigt(schritte[i], schritte[i].getAttribute('data-step'))) return schritte[i];
      }
      // sonst der nächste sichtbare überhaupt
      for (var j = start; j < schritte.length; j++) if (sichtbar(schritte[j])) return schritte[j];
      return null;
    }

    function zeichnen() {
      var nr = 0;
      var offeneNamen = [];
      var punkte = '';

      var ersterOffenNr = 0;
      schritte.forEach(function (schritt) {
        var name = schritt.getAttribute('data-step');
        var da = sichtbar(schritt);
        schritt.hidden = !da;
        if (!da) return;

        nr += 1;
        var fertig = erledigt(schritt, name);
        if (!fertig) {
          offeneNamen.push(schritt.querySelector('.km-step__titel').textContent.trim());
          if (!ersterOffenNr) ersterOffenNr = nr;
        }

        schritt.querySelector('.km-step__nr').textContent = nr;
        var wahl = schritt.querySelector('.km-step__wahl');
        wahl.textContent = zusammenfassung(name, schritt);
        wahl.classList.toggle('is-hinweis', hinweisNoetig(schritt, name));
        schritt.classList.toggle('is-fertig', fertig);

        var status = schritt.querySelector('[data-step-status]');
        status.className = 'km-step__status ' + (fertig ? 'is-fertig' : 'is-offen');
        status.innerHTML = fertig ? haken(13) : '';

        punkte += '<span class="km-fortschritt__punkt' + (fertig ? ' is-fertig' : '') + '">' +
          (fertig ? haken(11) : nr) + '</span>';
      });

      if (leiste) {
        var gesamt = nr;
        var offen = offeneNamen.length;
        if (leisteText) {
          // Die Nummer des ersten offenen Schritts, nicht "gesamt minus offen": Material,
          // Befestigung, Handlauf und Set sind vorbelegt, also gleich erledigt. Die alte
          // Rechnung meldete dann "Schritt 5 von 5", obwohl die Masse (Schritt 3) fehlte.
          leisteText.textContent = offen === 0
            ? 'Alle ' + gesamt + ' Schritte erledigt'
            : 'Schritt ' + ersterOffenNr + ' von ' + gesamt;
        }
        if (leistePunkte) leistePunkte.innerHTML = punkte;
        if (leisteWeiter) leisteWeiter.hidden = offen === 0;
      }

      if (zeitFeld) {
        var beschichtet = wert('material') === 'pulverbeschichtet';
        // Ohne Freigabeschleife entfallen die ersten beiden Etappen.
        var sofort = wert('fertigungsstart') === 'sofort';
        zeitPunkte.forEach(function (punkt, i) { punkt.hidden = sofort && i < 2; });
        // Die Zusage zur Freigabezeichnung darf nicht stehen bleiben, wenn der Kunde
        // die Sofortfertigung gewaehlt hat - sonst widerspricht die Seite sich selbst.
        if (hilfeZusage) {
          hilfeZusage.textContent = sofort
            ? 'Sie haben die Sofortfertigung gewählt: Wir fertigen ohne Maßzeichnung direkt nach Ihren Angaben. Bei Unsicherheit rufen Sie uns lieber kurz an.'
            : 'Vor der Fertigung erhalten Sie eine Maßzeichnung mit allen Maßen zur Prüfung und Freigabe – kostenlos. Erst danach geht Ihr Balkon in die Fertigung.';
        }

        if (zeitVorsatz) {
          zeitVorsatz.textContent = sofort
            ? 'Wir fertigen direkt nach Ihren Maßen – ohne Zeichnung und Rückfrage.'
            : 'Die Fertigung beginnt, sobald Sie die Maßzeichnung freigegeben haben.';
        }
        zeitFeld.textContent = beschichtet ? '12–20 Werktage' : '8–12 Werktage';
        if (zeitHinweis) {
          zeitHinweis.textContent = beschichtet
            ? ' Die Pulverbeschichtung kommt als eigener Arbeitsgang nach dem Verzinken dazu.'
            : '';
        }
      }

      if (offenHinweis) {
        if (offeneNamen.length) {
          offenHinweis.textContent = 'Noch offen: ' + offeneNamen.join(', ');
          offenHinweis.hidden = false;
        } else {
          offenHinweis.hidden = true;
        }
      }
    }

    // Hinweisfelder: der Info-Knopf klappt sie auf, statt eine Hover-Blase zu zeigen.
    // Auf Touch-Geraeten gibt es kein Hover, und die Aufmasshilfe braucht klickbare Links.
    root.querySelectorAll('.km-f__info[data-tipp-fuer]').forEach(function (knopf) {
      var feld = document.getElementById(knopf.getAttribute('data-tipp-fuer'));
      if (!feld) return;
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var auf = feld.hidden;
        feld.hidden = !auf;
        knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
        knopf.classList.toggle('is-auf', auf);
      });
    });

    // --- Bedienung ---
    schritte.forEach(function (schritt) {
      var knopf = schritt.querySelector('.km-step__toggle');
      knopf.addEventListener('click', function () {
        var war = schritt.classList.contains('is-offen');
        // Position der angeklickten Kopfzeile merken. Wird ein weiter oben stehender
        // Schritt zugeklappt, verschwindet dessen Hoehe schlagartig - beim Masse-Schritt
        // mit der Skizze mehrere hundert Pixel. Ohne Ausgleich rutscht der angeklickte
        // Schritt unter dem Finger weg und der Blick landet auf dem Preisblock darunter.
        var vorher = schritt.getBoundingClientRect().top;
        schritte.forEach(function (s) { aufklappen(s, false); });
        aufklappen(schritt, !war);
        zeichnen();
        var diff = schritt.getBoundingClientRect().top - vorher;
        if (Math.abs(diff) > 2) window.scrollBy(0, diff);
      });
    });

    if (leisteWeiter) {
      leisteWeiter.addEventListener('click', function () {
        // Vom aktuell offenen Schritt aus weitersuchen, sonst landet man immer wieder
        // beim ersten offenen Schritt - der Knopf wirkt dann wie ohne Funktion.
        var ziel = naechsterOffener(aktive()) || naechsterOffener(null);
        if (!ziel) return;
        schritte.forEach(function (s) { aufklappen(s, false); });
        aufklappen(ziel, true);
        zeichnen();
        ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    form.addEventListener('input', function (e) { merkeBeruehrung(e.target); zeichnen(); });
    form.addEventListener('change', function (e) { merkeBeruehrung(e.target); zeichnen(); });
    // Die Schrittknöpfe für Breite/Höhe sind eigene Buttons, kein input-Ereignis am Feld.
    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest && e.target.closest('.km-f__step');
      if (stepBtn && (stepBtn.getAttribute('data-for') === 'breite' || stepBtn.getAttribute('data-for') === 'hoehe')) {
        beruehrt.masse = true;
        setTimeout(zeichnen, 0);
      }
    });

    // Sichtbarkeit der bedingten Felder ändert km-konfigurator.js; darauf reagieren.
    var beobachter = new MutationObserver(function () { zeichnen(); });
    root.querySelectorAll('[data-show-if]').forEach(function (el) {
      beobachter.observe(el, { attributes: true, attributeFilter: ['hidden'] });
    });

    // Leiste nur zeigen, solange der Konfigurator im Blickfeld ist.
    if (leiste && 'IntersectionObserver' in window) {
      var wache = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { leiste.hidden = !e.isIntersecting; });
      }, { rootMargin: '-80px 0px -40% 0px' });
      wache.observe(form);
    }

    // Startzustand: alles zu, Schritt 1 auf. Bewusst NICHT der erste unerledigte
    // Schritt: Material und Befestigung sind vorausgewaehlt und gelten damit als
    // erledigt, der Konfigurator wuerde mitten in der Masseingabe aufgehen.
    schritte.forEach(function (s) { aufklappen(s, false); });
    if (schritte[0]) aufklappen(schritte[0], true, false);
    zeichnen();
  }

  document.querySelectorAll('.km-konfform[data-section-id]').forEach(init);
})();
